/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { Theme } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";

export const styles = ({ palette, spacing }: Theme) => createStyles({

    container : {
        maxWidth: "800px"
    },

    marginAuto : {
        margin: "auto"
    },

    left : {
        background: palette.secondary.light,
        padding: spacing.unit * 4,
        minHeight: 400,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },

    form : {
        padding: spacing.unit * 4,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },

    title : {
        marginBottom: spacing.unit * 2
    },

    subtitle : {
        textTransform: "uppercase",
        marginBottom: spacing.unit * 2
    }

});



// WEBPACK FOOTER //
// ./src/pages/PageLogin/PageLogin.style.tsx